import defaultLocale from './default';
export default defaultLocale;
//# sourceMappingURL=index.js.map